import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { InsightPassengerModel, InvoiceIndividualDetailModel, InvoiceIndividualSearchModel } from 'src/app/core/models/individual-model';
import { InvoiceIndividualDetailComponent } from './invoice-individual-detail/invoice-individual-detail.component';
import { InvoiceIndividualSearchComponent } from './invoice-individual-search/invoice-individual-search.component';
import { OrderAddress, OrderDataModel, OrderJsonModel, OrderPartnerModel } from 'src/app/core/models/order-model/order-json';
import { InvoiceIndividualDetailMapperService } from './invoice-individual-detail/invoice-individual-detail-mapper.service';
import { InsightPassengerService } from 'src/app/core/services/individul-services';
import { LoadingSpinnerService } from 'src/app/shared/layout/loading-spinner';
import { cloneDeep } from 'lodash';
import { PaymentAddressView } from 'src/app/core/models/payment-models/payment-address.model';
import { PaymentDocumentInvoiceMapper } from '../shared/payment-document-invoice-mapper.service';
import { OrderPartnerRole, OrderStateCode } from 'src/app/core/constants/order-constants';

@Component({
    selector: 'op-individual-document-invoice',
    templateUrl: './individual-document-invoice.component.html',
    providers: [
        PaymentDocumentInvoiceMapper
    ]
})
export class IndividualDocumentInvoiceComponent {
    public selectedIndividual: InvoiceIndividualSearchModel;

    public orderJson: OrderJsonModel;
    public orderPartnerContact: OrderPartnerModel;

    public insightPassenger: InsightPassengerModel;

    @Output() onIndividualSelected = new EventEmitter<InvoiceIndividualSearchModel>();

    @ViewChild(InvoiceIndividualSearchComponent) searchComponent: InvoiceIndividualSearchComponent;
    @ViewChild(InvoiceIndividualDetailComponent) detailComponent: InvoiceIndividualDetailComponent;

    constructor(private invoiceIndividualDetailMapperService: InvoiceIndividualDetailMapperService,
        private insightPassengerService: InsightPassengerService,
        private spinnerService: LoadingSpinnerService,
        private paymentDocumentInvoiceMapper: PaymentDocumentInvoiceMapper) { }

    onSelectIndividual(individual: InvoiceIndividualSearchModel) {
        this.selectedIndividual = individual;
        this.getIndividualDetail(individual.individualId, individual.individualAddressId);
        this.onIndividualSelected.emit(this.selectedIndividual);
    }

    onClearIndividual() {
        this.selectedIndividual = null;
        this.searchComponent.displaySearchResult = false;
        this.onIndividualSelected.emit(null);
    }

    get hideSearch(): boolean {
        return !!this.selectedIndividual
    }

    public focusSearchCondition() {
        this.searchComponent.focusSearchCondition();
    }

    public getIndividualDetail(individualId: string, individualAddressId: string, contact: boolean = false) {
        if (!individualId) return;
        this.spinnerService.show();
        this.insightPassengerService.getInsightPassenger(individualId)
            .subscribe(
                (response: InsightPassengerModel) => {
                    this.insightPassenger = cloneDeep(response);
                    let invoiceIndividual = this.invoiceIndividualDetailMapperService.InsightPassengerDetailToInvoiceIndividual(response, individualAddressId);
                    this.detailComponent.insightAddresses = response.insightPassengerAddresses;
                    this.detailComponent.getUseAddress(response.insightPassengerAddresses, invoiceIndividual, individualAddressId);
                    this.spinnerService.hide();
                    if (contact) return;
                    this.setInvoiceDetail(invoiceIndividual);
                },
                () => this.spinnerService.hide()
            )
    }

    public setOrderContact(order: OrderJsonModel) {
        this.orderJson = order;
        const orders = order?.oopsOrder?.order;
        if (!orders) return;
        let contact = orders.find(x => x.orderState?.code == OrderStateCode.Partner && x.orderPartner?.find(y => y.orderPartnerRole?.code == OrderPartnerRole.Contact));
        let contactAddress = this.getContactAddress(contact.orderId, orders);
        if (contact) {
            let invoiceIndividual = this.invoiceIndividualDetailMapperService.orderPartnerContactToInvoiceIndividual(contact, orders);
            this.selectedIndividual = invoiceIndividual;
            this.getIndividualDetail(contact.orderPartner?.[0]?.individualId, contactAddress?.addressId, true);
            this.setInvoiceDetail(invoiceIndividual);
        }
    }

    private setInvoiceDetail(invoiceIndividual: InvoiceIndividualDetailModel) {
        this.detailComponent.setContactDetailToIndividual(invoiceIndividual);
    }

    public onNewIndividual() {
        this.selectedIndividual = null;
    }

    public validatePaymentIndividual(): boolean {
        return !!this.selectedIndividual;
    }

    public validatePaymentAddress() {
        return this.detailComponent?.validatePaymentAddress()
    }

    public getPaymenAddress(): PaymentAddressView {
        let address = this.paymentDocumentInvoiceMapper.invoiceIndividualToPaymentAddress(this.detailComponent?.getIndividualDetailAndAddress());
        return address;
    }

    public focusAddress() {
        setTimeout(() => {
            this.detailComponent.focusAddress();
        }, 100);
    }

    public getErrorMessagePaymentAddress(): string {
        return this.detailComponent?.getErrorMessagePaymentAddress();
    }

    private getContactAddress(contctOrderId: string,orders: OrderDataModel[]) : OrderAddress {
        let contactAddresses = orders?.filter(x => x.orderState?.code == OrderStateCode.Address && x.parentOrderId == contctOrderId && !x.deletedFlag);
        if (contactAddresses?.length) {
            return contactAddresses[contactAddresses.length -1].orderAddress[0];
        }
        return null;
    }
}
